import script from "./PosReceiptPrint.vue?vue&type=script&setup=true&lang=js"
export * from "./PosReceiptPrint.vue?vue&type=script&setup=true&lang=js"

import "./PosReceiptPrint.vue?vue&type=style&index=0&id=55c7d727&lang=css"
import "./PosReceiptPrint.vue?vue&type=style&index=1&id=55c7d727&scoped=true&lang=css"

import exportComponent from "/Users/amsrafid/Projects/www/miaccounts-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55c7d727"]])

export default __exports__